module.exports = __webpack_public_path__ + "images/copy-button-hover-d8237201.svg";